var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"show":"","dismissible":"","variant":_vm.alert.type}},[_c('h6',{staticClass:"alert-content"},[_vm._v(_vm._s(_vm.alert.message))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }